document.getElementById("downloadCSV").addEventListener("click", function () {

  let clickedElement = this;  
  let totalProductsCount = Number(this.getAttribute("data-totalCount"));
  let fetchRequestsCount = Math.ceil(totalProductsCount / 48);

  let csvContent = "data:text/csv;charset=utf-8,";
  csvContent += "Product Name,Variant Title,SKU,Quantity,Price,Minimum Advertised Price,Flat Shipping Price,Final Sale\n"; // Updated CSV Headers
  this.textContent = "Started";
  this.disabled = true; 


  // Warning before page unload
  const beforeUnloadHandler = (e) => {
    e.preventDefault();
    e.returnValue = 'Download is in progress. Are you sure you want to leave?';
    return 'Download is in progress. Are you sure you want to leave?';
  };
  
  // Add the warning
  window.addEventListener('beforeunload', beforeUnloadHandler);
  function csvEscape(value) {
    if (value == null) return '""';
    const v = value.toString().replace(/"/g, '""');
    return `"${v.replace(/\r?\n/g, ' ')}"`; // keep it one line
  }  


  async function fetchDataInSequence() {
  
    try {
      // Loop through all pages and collect data
      for(let i = 1; i <= fetchRequestsCount; i++) {
        console.log(`Fetching page ${i} of ${fetchRequestsCount}`);  
        let response = await fetch(`https://trade.tovfurniture.com/collections/all-products-pricing?page=${i}`);
        if (!response.ok) throw new Error(`HTTP ${response.status} on page ${i}`);
        let data = await response.text();
        let progress = Math.round((i/fetchRequestsCount) * 100);
        if(progress >= 100) {
          clickedElement.textContent = "Completed";
        }
        else {
          clickedElement.textContent = `In Progress (${progress}%)`;
        }        
        dataProcessing(data); // This will append to csvContent
        
      }
      
      // After all data is collected, create and download the CSV
      let encodedUri = encodeURI(csvContent);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "wholesale_pricing.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up
      
    } 
    catch (error) {
      console.log("General error:", error);
      clickedElement.textContent = "Failed";

    } 
    finally {
      // Reset button text only after all operations complete
      // document.getElementById("downloadCSV").textContent = "Download";
      setTimeout(() => {        
        clickedElement.textContent = "Download";
        document.getElementById("downloadCSV").disabled = false; 
      }, 2000);
    }     
    
  }

  function dataProcessing(data) {    
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const gridItem = Array.from(doc.body.querySelectorAll("#product-grid .grid__item"));
    console.log("gridItem:", gridItem);
    gridItem.forEach(function (item) {
      console.log("item:", item);
      let productTitle = item.querySelector(".catalog-product-title").innerHTML;
      const variantDataWrapper = item.querySelectorAll(".catalog-variant-data-wrapper");
      variantDataWrapper.forEach(function (variant) {
        let variantTitle = variant.querySelector(".catalog-variant-title").innerHTML;
        let variantSku = variant.querySelector(".catalog-variant-sku").innerHTML;
        let variantInventory = variant.querySelector(".catalog-variant-inventory").innerHTML;
        let variantPrice = variant.querySelector(".catalog-variant-price").innerHTML;
        let variantMap = variant.querySelector(".catalog-map").innerHTML;
        let variantFlatShippingPrice = variant.querySelector(".catalog-flat-shipping-price").innerHTML;
        let variantFinalSale = variant.querySelector(".catalog-final-sale").innerHTML;
        // csvContent += `${productTitle},${variantTitle},${variantSku},${variantInventory},${variantPrice},${variantMap},${variantFlatShippingPrice}\n`;
        csvContent += [productTitle, variantTitle, variantSku, variantInventory, variantPrice, variantMap, variantFlatShippingPrice, variantFinalSale].map(csvEscape).join(',') + '\n';        
      });
    });
  }
  fetchDataInSequence();
});